'use strict'

/**
 * Generates an array of filter category objects for store filtering, each containing an id, a localized label, and a list of filter options.
 * @param {function} formatMessage - A function for internationalizing labels, typically from react-intl, which accepts an object with `id` and `defaultMessage` properties and returns a localized string.
 * @returns {Array<Object>} An array of filter category objects, each with `id`, `label`, and `options` properties for use in store filtering UIs.
 */
export const createFilterCategories = (formatMessage) => [
    {
        id: 'collections',
        label: formatMessage({
            defaultMessage: 'Collections',
            id: 'stores_filters.filter.collections'
        }),
        options: [
            {
                name: 'men',
                label: formatMessage({id: 'stores_page.men', defaultMessage: 'Men'})
            },
            {
                name: 'women',
                label: formatMessage({id: 'stores_page.women', defaultMessage: 'Women'})
            },
            {
                name: 'kids',
                label: formatMessage({id: 'stores_page.kids', defaultMessage: 'Kids'})
            }
        ]
    },
    {
        id: 'types',
        label: formatMessage({
            defaultMessage: 'Store types',
            id: 'stores_filters.filter.types'
        }),
        options: [
            {
                name: 'VS',
                label: formatMessage({
                    id: 'stores_page.store_vbq',
                    defaultMessage: 'Vilebrequin stores'
                })
            },
            {
                name: 'VO',
                label: formatMessage({
                    id: 'stores_page.store_outlet',
                    defaultMessage: 'Outlet stores'
                })
            },
            {
                name: 'OS',
                label: formatMessage({
                    id: 'stores_page.store_others',
                    defaultMessage: 'Others stores'
                })
            }
        ]
    },
    {
        id: 'services',
        label: formatMessage({
            defaultMessage: 'Services',
            id: 'stores_filters.filter.services'
        }),
        options: [
            {
                name: 'monogramming',
                label: formatMessage({
                    id: 'stores_page.monogramming',
                    defaultMessage: 'In Store Monogramming'
                })
            }
        ]
    }
]
